/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSubscriptionDto } from '../../models/create-subscription-dto';
import { SubscriptionDto } from '../../models/subscription-dto';

export interface SubscribeControllerCreate$Params {
      body: CreateSubscriptionDto
}

export function subscribeControllerCreate(http: HttpClient, rootUrl: string, params: SubscribeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscribeControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionDto>;
    })
  );
}

subscribeControllerCreate.PATH = '/api/subscribe';
